const ERROR_MAPPING = [
  {
    status: 'INCOMPLETE',
    message: 'Please verify and update your date of birth',
    errorType: 'INVALID_DATE_OF_BIRTH',
    affectedFields: ['dateOfBirth'],
  },
  {
    status: 'REVIEW',
    message: 'Invalid request for application-qualify: Phone number is already in use',
    errorType: 'PHONE_NUMBER_ALREADY_IN_USE',
    affectedFields: ['phone'],
  },
  {
    status: 'REVIEW',
    message: 'Invalid request for application-qualify: SSN already in use',
    errorType: 'SSN_ALREADY_IN_USE',
    affectedFields: ['socialSecurityNumber'],
  },
  {
    status: 'REVIEW',
    message:
      'Invalid request for application-qualify: Invalid field: ValidationError: Only phone numbers with 10 digits are accepted. [Code: 2028]',
    errorType: 'PHONE_NUMBER_INVALID',
    affectedFields: ['phone'],
  },
  {
    status: 'REVIEW',
    message:
      'Invalid request for application-qualify: Email is already in use and phone number is already in use',
    errorType: 'PHONE_NUMBER_INVALID',
    affectedFields: ['phone', 'email'],
  },
];

const ERROR_TYPES = {
  PHONE_NUMBER_ALREADY_IN_USE: 'PHONE_NUMBER_ALREADY_IN_USE',
  SSN_ALREADY_IN_USE: 'SSN_ALREADY_IN_USE',
};

export { ERROR_MAPPING, ERROR_TYPES };
